/**
 * @file JobApplicationRecruiterStatusesTranslationsSlot.tsx
 *
 * @fileoverview Allow to adjust job application recruiter statuses.
 */

import { RecruiterStatus } from '~/jobiqo/types/types';
import React from 'react';

/**
 * Returns job application recruiter statuses translations.
 * @param statuses The job application recruiter statuses translations.
 * @returns The job application recruiter statuses translations.
 */
export function getJobApplicationRecruiterStatusesTranslationsSlot(
  statuses: Record<
    RecruiterStatus,
    { label: React.ReactNode; tooltip: React.ReactNode }
  >,
) {
  return statuses;
}
